export default function HiDreamLogo() {
  return <img src="/logos/hidream-logo.png" alt="HiDream" width="16" height="16" className="block" />
}
